// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"124":"3a16741d","264":"c5915626","453":"027ba686","480":"226606ba","738":"4077fe64"}[chunkId] + ".chunk.js";
};